import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "What is a trademark and why do I need one?",
      answer: "A trademark is a word, phrase, symbol, design, or combination that identifies and distinguishes your goods or services from others. Federal trademark registration gives you exclusive nationwide rights to use your mark, legal protection against infringement, and increases your brand's value. It prevents competitors from using similar marks and gives you the right to sue infringers in federal court.",
    },
    {
      question: "How long does the trademark registration process take?",
      answer: "The typical USPTO trademark registration process takes 8-12 months from filing to registration. However, the timeline can vary based on several factors including the complexity of your mark, whether office actions are issued, and the current USPTO backlog. We file your application within 24-48 hours of receiving your information, and the initial USPTO review typically occurs 3-4 months after filing.",
    },
    {
      question: "What's the difference between TM and ® symbols?",
      answer: "The TM symbol can be used immediately when you start using a mark in commerce, even before registration. It indicates you're claiming trademark rights. The ® symbol can only be used after your trademark is officially registered with the USPTO. Using ® before registration is illegal and can result in penalties. Once registered, you should use ® to maximize your legal protections.",
    },
    {
      question: "How much does trademark registration cost?",
      answer: "Our service fees range from $45 to $349 depending on the package you choose. Additionally, the USPTO charges government filing fees of $250-$350 per class of goods/services (this is separate from our service fee). Most businesses file in 1-2 classes. We offer transparent pricing with no hidden fees, and our packages include everything from basic filing to comprehensive search, monitoring, and legal support.",
    },
    {
      question: "What happens if my trademark application is rejected?",
      answer: "If the USPTO issues an office action (objection), our experienced attorneys will review it and craft a legal response at no additional cost for our Enhanced, Deluxe, and Platinum packages. Common issues include likelihood of confusion with existing marks or descriptiveness concerns. We have a 98% success rate in overcoming office actions. If your mark is ultimately refused, we'll work with you to explore alternatives or filing strategies.",
    },
    {
      question: "Can I trademark a business name or logo?",
      answer: "Yes! You can trademark your business name, logo, slogan, or any combination of these. In fact, many businesses file separate applications for their word mark (business name) and design mark (logo) to maximize protection. We'll advise you on the best filing strategy based on how you use your brand and your business goals.",
    },
    {
      question: "Do I need to trademark in multiple classes?",
      answer: "It depends on your business offerings. Trademark classes categorize different types of goods and services (there are 45 classes total). If you only sell one type of product, you may only need one class. However, if you offer multiple product types or services, you'll need multiple classes. For example, a clothing brand that also sells accessories might need 2-3 classes. We'll help you identify all necessary classes during consultation.",
    },
    {
      question: "What's included in a trademark search?",
      answer: "Our comprehensive trademark search includes reviewing the USPTO federal database for registered and pending trademarks, state trademark registries, common law sources, business name databases, and domain names. We identify potential conflicts, assess the strength of your mark, and provide a detailed report with our professional recommendation on whether to proceed with filing.",
    },
    {
      question: "How long does trademark protection last?",
      answer: "Federal trademark registration lasts 10 years and can be renewed indefinitely as long as you're still using the mark in commerce. However, you must file a Declaration of Use between years 5-6 to maintain your registration. We offer monitoring and maintenance services to ensure you never miss critical deadlines and your protection remains active.",
    },
    {
      question: "Can I file a trademark myself without an attorney?",
      answer: "While it's legally possible to file without an attorney, it's not recommended. The USPTO reports that over 50% of pro se (self-filed) applications encounter serious problems or are abandoned. Trademark law is complex, and mistakes can be costly. Our attorneys know how to navigate the process, avoid common pitfalls, respond to office actions, and maximize your chances of approval, saving you time, money, and stress.",
    },
  ];

  return (
    <section id="faqs" className="faq-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">
            Everything You Need to Know About Trademark Registration
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? "active" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <span>{faq.question}</span>
                <ChevronDown
                  className={`faq-icon ${openIndex === index ? "rotated" : ""}`}
                  size={20}
                />
              </button>
              <div className={`faq-answer ${openIndex === index ? "open" : ""}`}>
                <p>{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
